import React, {useState} from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import {Col, Row, Spinner} from "react-bootstrap";
import DateBox from "../../../../primer/DateBox";
import moment from "moment";
import BetterCheckBox from "../../../../common/BetterCheckBox";
import {isEmpty, validateEmail} from "../../../../../_helpers/commonFunctions";
import axios from "axios";
import Alert from "react-bootstrap/Alert";
import Input from "../../../../common/Input";

const MassFetchModal = ({show, setShow}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const [requestData, setRequestData] = useState({
        date_from: moment().startOf("month").format("DD/MM/YYYY"),
        date_to: moment().format("DD/MM/YYYY"),
        fetchPatients: false,
        fetchPrescriptions: false,
        fetchReferrals: false,

        sendEmail: false,
        emails: "",
    })
    const [loading, setLoading] = useState(false);

    const handleHide = () => {
        if (!loading) {
            setShow(false);
        } else {
            toast.info("Παρακαλώ περιμένετε να τελειώσει η διαδικασία της άντλησης.");
        }
    }

    const handleMassFetch = () => {
        if (!requestData.fetchPatients && !requestData.fetchPrescriptions && !requestData.fetchReferrals) {
            return toast.info("Παρακαλώ επιλέξτε τουλάχιστον έναν τύπο άντλησης.");
        } else if (isEmpty(requestData.date_from) || isEmpty(requestData.date_to)) {
            return toast.info("Παρακαλώ συμπληρώστε ημερομηνία από και έως.");
        }
        const momentFrom = moment(requestData.date_from, "DD/MM/YYYY").hour(1);
        const momentTo = moment(requestData.date_to, "DD/MM/YYYY").hour(2);
        if (momentFrom > momentTo) {
            return toast.info("Η ημερομηνία από πρέπει να είναι μικρότερη από την ημερομηνία έως.");
        } else if (momentFrom.year() < 2017) {
            return toast.info("Η ημερομηνία από δεν μπορεί να είναι μικρότερη του έτους 2017.");
        }

        if (requestData.sendEmail) {
            if (isEmpty(requestData.emails)) {
                return toast.info("Παρακαλώ συμπληρώστε κάποιο e-mail.");
            } else if (String(requestData.emails).split(",").filter(Boolean).some((email) => !validateEmail(email))) {
                return toast.info("Παρακαλώ βεβαιωθείτε ότι όλα τα e-mail είναι σωστά.");
            }
        }

        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/mass-fetch`, {
            ...requestData,
            company: company.id,
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                setShow(false);
                toast.success(res.data.message);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOnChange = (e, type, name) => {
        if (type === "db") {
            if (moment(e).isValid()) {
                setRequestData({...requestData, [name] : moment(e).format("DD/MM/YYYY")})
            } else {
                setRequestData({...requestData, [name] : ""})
            }
        } else if (type === "cb") {
            setRequestData({...requestData, [name] : e.target.checked});
        } else if (type === "input") {
            setRequestData({...requestData, [name] : e.target.value});
        }
    }

    return (
        <React.Fragment>
            <Modal show={show} backdrop={"static"} onHide={() => handleHide()} dialogClassName={"modal42PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Άντληση δεδομένων από ΗΔΙΚΑ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{pointerEvents: loading ? "none" : "", opacity: loading ? "0.6" : ""}}><Row>
                        <Col md={6}>
                            <DateBox
                                name={"date_from"}
                                label={"Ημερομηνία από"}
                                allowOtherYears={true}
                                required={true}
                                selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""}
                                onChange={(e) => handleOnChange(e, "db", "date_from")}
                            />
                        </Col>
                        <Col md={6}>
                            <DateBox
                                name={"date_to"}
                                label={"Ημερομηνία έως"}
                                allowOtherYears={true}
                                required={true}
                                selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""}
                                onChange={(e) => handleOnChange(e, "db", "date_to")}
                            />
                        </Col>
                    </Row>
                        <Row className={"mt-4"}>
                            <Col md={12}>
                                <BetterCheckBox
                                    name={"fetchPatients"}
                                    text={"Άντληση ασθενών"}
                                    checked={requestData.fetchPatients}
                                    onChange={(e) => handleOnChange(e, "cb", "fetchPatients")}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <BetterCheckBox
                                    name={"fetchPrescriptions"}
                                    text={"Άντληση συνταγών"}
                                    checked={requestData.fetchPrescriptions}
                                    onChange={(e) => handleOnChange(e, "cb", "fetchPrescriptions")}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <BetterCheckBox
                                    name={"fetchReferrals"}
                                    text={"Άντληση παραπεμπτικών"}
                                    checked={requestData.fetchReferrals}
                                    onChange={(e) => handleOnChange(e, "cb", "fetchReferrals")}
                                />
                            </Col>
                        </Row>
                        <Alert variant={"secondary"}>
                            <Row>
                                <Col md={12}>
                                    Η διαδικασία μπορεί να διαρκέσει αρκετό χρόνο. Αν δεν επιθυμείτε να περιμένετε, υπάρχει η δυνατότητα αποστολής e-mail όταν τελειώσει.
                                </Col>
                                <Col md={12}>
                                    <BetterCheckBox
                                        name={"sendEmail"}
                                        className={"mt-2"}
                                        text={"Αποστολή e-mail"}
                                        checked={requestData.sendEmail}
                                        onChange={(e) => handleOnChange(e, "cb", "sendEmail")}
                                    />
                                </Col>
                                {requestData.sendEmail && (
                                    <Col md={12}>
                                        <Input
                                            name={"emails"}
                                            label={"e-mails διαχωρισμένα με κόμμα (,)"}
                                            placeholder={"Εισαγάγετε e-mails διαχωρισμένα με κόμμα (,)"}
                                            onChange={(e) => handleOnChange(e, "input", "emails")}
                                        />
                                    </Col>
                                )}
                            </Row>
                        </Alert>
                    </div>
                    {loading && (
                        <div style={{textAlign: "center"}}>
                            Γίνεται άντληση παρακαλώ περιμένετε... <Spinner size={"sm"} className={"ml-2"} animation={"border"} variant={"dark"} />
                        </div>
                    )}
                </Modal.Body>
                {!loading && (
                    <Modal.Footer>
                        <Button variant="outline-primary" onClick={() => setShow(false)}>
                            Κλείσιμο
                        </Button>
                        <Button variant="primary" onClick={() => handleMassFetch()}>
                            Μαζική άντληση
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        </React.Fragment>
    )
}

export default MassFetchModal
